import {Component, OnInit} from '@angular/core';

import {ComplianceArea, ControlItem} from '../../_models/index';

import {Role} from '../../helpers/index';

import {GenericControl} from "../../_models/genericControl";
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {EditBulletinComponent} from "../editBulletin";
import {CreateBulletinComponent} from "../createBulletin";
import {GenericControlService} from "../../_services/genericControl.service";
import {DictionaryItem} from "../../_models/dictionaryItem";
import {SelectControlItemComponent} from "../selectControlItem/select-control-item.component";
import {SelectDictionaryItemComponent} from "../selectDictionaryItem/select-dictionary-item.component";
import {ListMessageComponent} from "../listMessage";
import {AlertService} from "../../_services";
import { Constants } from '../../helpers/constants';

@Component({
  standalone: false,
  selector: 'control-item-component',
  templateUrl: 'genericControls.component.html',
  styleUrls: ['./genericControls.component.scss'],
})

export class GenericControlsComponent implements OnInit {
  loading = false;
  genericControls: GenericControl[];
  controlItems: ControlItem[] = [];
  topics: DictionaryItem[] = [];
  constants = Constants;

  constructor(
    public dialog: MatDialog,
    public alertService: AlertService,
    public genericControlService: GenericControlService,
  ) {
  }

  ngOnInit() {
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    this.loadGenericControls();
  }

  onClose(): void {
    this.loadGenericControls();
  }


  createGenericControl() {
    this.genericControls.push({editMode: true, controlItems: [], topics: []});
  }

  loadGenericControls() {
    this.genericControlService.getGenericControls().subscribe(data => {
      this.genericControls = data;
    });
  }
  save(item: GenericControl) {
    this.genericControlService.saveGenericControl(item).subscribe(data => {
      this.loadGenericControls();
    });
  }

  delete(id) {
    this.genericControlService.deleteGenericControl(id).subscribe(data => {
      this.loadGenericControls();
    });
  }

  addControlItem(item) {
    let config: MatDialogConfig = {
      width: "90%",
      height: "90%",
      data: {
        except: item.controlItems || []
      }
    };

    let selectDialogRef = this.dialog.open(SelectControlItemComponent, config);

    selectDialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        item.controlItems.push(data);
      }
    });
  }

  addTopic(item) {
    let config: MatDialogConfig = {
      width: "90%",
      height: "90%",
      data: {
        dictionary: 'Topic',
        except: item.topics || []
      }
    };

    let selectDialogRef = this.dialog.open(SelectDictionaryItemComponent, config);

    selectDialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        item.topics.push(data);
      }
    });
  }

  import(event) {
    this.alertService.clear();
    let attachments = event.target.files;
    if (attachments.length > 0) {
      let file: File = attachments[0];
      this.genericControlService.import(file).subscribe(
        (res) => {
          let config: MatDialogConfig = {
            panelClass: 'custom-overlay-pane-class',
            width: 'auto',
            height: '90%',
            data: {
              items: res,

              title: "Import report"
            }
          };
          this.dialog.open(ListMessageComponent, config);
          this.loadGenericControls();
        },
        (error) => {
          const errorMessage = 'An error occurred while upload control items.';
          this.alertService.error(errorMessage);
        });
    }
  }
}
